<template>
  <div class="authc-user account-page">
    <div class="header">
      <span class="back-btn" type="text" @click="$router.go(-1)">&lt;&lt;返回</span>
      <span class="title">个人实名认证</span>
    </div>
    <el-steps :active="step" align-center process-status="finish" finish-status="success" class="authc-steps">
      <el-step title="认证信息"></el-step>
      <el-step title="信息审核"></el-step>
      <el-step title="认证完成"></el-step>
    </el-steps>
	<div v-if="step === 1" class="content">
		<div class="form">
			<div class="row clearfix">
				<div class="row-title">手机号码 :</div>
					<div class="row-content">
						{{ $store.state.username }}
					</div>
					<div class="row-hint"></div>
				</div>
				<div class="row clearfix">
					<div class="row-title requisite">姓名 :</div>
					<div class="row-content">
						<el-input v-model.trim="formData.name" placeholder="请输入您的姓名" @blur="verifyName"></el-input>
					</div>
					<div class="row-hint error-info">{{ errors.name }}</div>
				</div>
				<div class="row clearfix">
					<div class="row-title requisite">身份证号码 :</div>
					<div class="row-content">
						<el-input v-model.trim="formData.idcard" maxlength="18" placeholder="请输入您的身份证号码" @blur="verifyIDcard"></el-input>
					</div>
					<div class="row-hint error-info">{{ errors.idcard }}</div>
				</div>
			<div>
				<div class="authentication-main-photo-nav">
					<div class="authentication-main-photo upload-photo" @click="choseFile('file2')">
						<img class="idcard" :src="formData.photo1url" alt="">
						<input type="file" name="file2" id="file2" style="display:none;" @change="upload('file2')"/>
					</div>
				<div class="authentication-main-photo upload-photo"  @click="choseFile('file3')">
						<img class="idcard" :src="formData.photo2url" alt="">
						<input type="file" name="file3" id="file3" style="display:none;" @change="upload('file3')"/>
					</div>
				</div>
			</div>
			<div class="row clearfix">
				<div class="row-title">&nbsp;</div>
				<div class="row-content">
					<el-button type="primary" @click="submitHandler">提交</el-button>
				</div>
				<div class="row-hint"></div>
			</div>
		</div>
	</div>
	<div v-if="step === 2" class="content">
		<div class="examine">
			<img class="" src="../../assets/icon/authing.png" style="width: 200px;" alt="">
		</div>
	</div>
  </div>
</template>

<script>
  import BaseUserInfo from '@/components/form/BasicInfoForm'
  import AddrThreeSelect from '@/components/fields/AddrThreeSelect'

  export default {
    name: 'User',
    components: {AddrThreeSelect, BaseUserInfo},
    data() {
      return {
		step: 1,
        industries: [],
		verifyIDcardFlag: true,
		verfyNameFlag: true,
        errors: {
          name: '',
          idcard: '',
          addr: '',
          industry: '',
        },
        formData: {
          name: '',
          idcard: '',
		  bank_card: '',
		  bank_cardurl: '',
          industry: '',
		  photo1: '',
		  photo2: '',
		  photo1url: 'https://dingdong-public.oss-cn-hangzhou.aliyuncs.com/uum/imgs/20200806/36a97337b1e2742b51b59e9e8c996fdf.png',
		  photo2url: 'https://dingdong-public.oss-cn-hangzhou.aliyuncs.com/uum/imgs/20200806/66d53412d6b83ba0680d905e3033bc1b.png',
		  type: '1'
        },
      }
    },
	watch: {
		
	},
    methods: {
      submitHandler() {
		this.verifyName()
		this.verifyIDcard()
        if (this.verifyIDcardFlag == false || this.verfyNameFlag == false) {
          return
        } else {
			this.$msgbox.confirm('请确认填写信息无误后提交?', '提交', {
				confirmButtonText: '提交',
				cancelButtonText: '取消',
				type: 'warning',
				center: true
			}).then(() => {
				this.$api.user.authUser(this.formData.name, this.formData.idcard, this.formData.photo1, this.formData.photo2, this.formData.phone, this.formData.banck_card, this.formData.type).then(res => {
					console.log(res)
					if (res.code === 0){
						this.$message({
							type: 'success',
							message: '提交成功!',
							offset: 80
						});
						this.step = 2
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消提交',
					offset: 80
				});
			});
			console.log('submit!')
		}
        // 提交
      },
	  verifyName (event) {
		  if (this.formData.name === ''){
			  this.verfyNameFlag = false
			  console.log('姓名不能为空')
			  this.errors['name'] = '姓名不能为空'
		  } else {
			  this.verfyNameFlag = true
			  this.errors['name'] = ''
		  }
	  },
	  verifyIDcard (event) {
	  	if (this.formData.idcard === ''){
	  		this.verifyIDcardFlag = false
	  		console.log('身份证号码不能为空')
	  		this.errors['idcard'] = '姓名不能为空'
	  	} else {
	  		let reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/
	  		if (!reg.test(this.formData.idcard)) {
	  		  this.verifyIDcardFlag = true
	  		  this.errors['idcard'] = '身份证号码不正确'
	  		} else {
				this.errors['idcard'] = ''
			}
		}
	  },
	  choseFile(id) {
	  	console.log(id);
	  	var f = document.getElementById(id);
	  	f.click();
	  	console.log('submit!');
	  },
	  upload(id) {
	  	var chosefile = document.getElementById(id).files[0]
	  	console.log(chosefile)
	  	this.$api.user.resPrivate(chosefile, 1).then(res => {
	  		console.log(res)
	  		switch (id) {
	  			case ('file2') :
	  				this.formData.photo1 = res.data.id
	  				this.formData.photo1url = res.data.url
	  				break
	  			case ('file3') :
	  				this.formData.photo2 = res.data.id
	  				this.formData.photo2url = res.data.url
	  				break
	  		}
	  	  // 1030 formKey过期 1012 验证码错误
	  	  // if (res.code === 0) {
	  	  //   this.smsError = ''
	  	  // } else {
	  	  //   this.smsError = res.msg
	  	  // }
	  	})
	  },
	  getAuthAudit() {
	  	this.$api.user.getAuthAudit().then(res => {
	  		console.log(res,'认证状态')
	  		if (res.code === 0) {
	  			switch (res.data.status) {
	  				case (0) :
	  					this.step = 1
	  					break
	  				case (1) :
	  					this.step = 2
	  					break
	  				case (2) :
	  					this.step = 1
						this.$msgbox({
							title: '审核未通过',
							message: res.data.msg,
							confirmButtonText: '重新提交',
							type: 'warning',
							center: true
						})
						this.$api.user.getAuthInfo().then(res => {
							console.log(res)
							if (res.code === 0){
								this.form.name = res.data.EntName
								this.form.code = res.data.EntCode
								this.form.photo1 = res.data.EntPhoto1
								this.form.photo2 = res.data.EntPhoto2
								this.form.auth_type = res.data.AuthType
								this.form.user_name = res.data.UserName
								this.form.user_id_card = res.data.UserCode
								this.form.user_photo1 = res.data.UserPhoto1
								this.form.user_photo2 = res.data.UserPhoto2
								this.$api.user.getResource (res.data.EntPhoto1).then(res => {
									 this.form.photo1url = res.data.url
								})
								this.$api.user.getResource (res.data.EntPhoto2).then(res => {
									 this.form.photo2url = res.data.url
								})
								this.$api.user.getResource (res.data.UserPhoto1).then(res => {
									 this.form.user_photo1url = res.data.url
								})
								this.$api.user.getResource (res.data.UserPhoto2).then(res => {
									 this.form.user_photo2url = res.data.url
								})
							}
						})
						// this.$msgbox.alert(res.msg + '请核对后重新提交', '审核未通过', {
						// 	confirmButtonText: '确认',
						// 	center: true,
						// callback: action  => {
						// 	// this.$message({
						// 	// 	type: 'info',
						// 	// 	message: `action: ${ action }`
						// 	// })
						//   }
						// });
	  					break
	  				case (3) :
	  					this.step = 3
	  					break
	  			}
	  		}else{
				return
			}
	  	})
	  }
    },
    created() {
	  this.getAuthAudit()
      this.$api.common.industry(0).then(res => {
        if (res.code == 0) {
          this.industries = res.data
        }
        console.log(res)
      })
    },
  }
</script>

<style scoped>
  .authc-steps {
    margin-top: 40px;
  }
  .content{
  	margin: 50px 200px;
  }
  .form {
    margin: 40px auto 0;
    width: 900px;
  }
  .form-hint {
    padding: 5px 0;
    margin-bottom: 20px;
    border: 1px solid #eee;
    background: #eee;
    text-align: center;
    color: #666;
    border-radius: 2px;
  }

  .error-info {
    color: red;
  }

  .row {
    height: 40px;
    line-height: 40px;
    margin-bottom: 25px;
  }

  .row-title {
    width: 160px;
    height: 40px;
    float: left;
    padding-right: 40px;
    text-align: right;
  }

  .row-content {
    width: 350px;
    float: left;
  }

  .row-hint {
    width: 310px;
    float: right;
    padding-left: 40px;
    color: red;
  }

  .red {
    color: red;
  }
  .authentication-main-photo-nav{
  	  height: 200px;
  }
  .authentication-main-photo {
  	  margin-right: 40px;
  	  float: left;
  }
  .idcard{
  	  width: 280px;
  }
  .upload-photo{
  	  cursor: pointer;
  }
  .examine{
	  width: 200px;
	  margin: 20px auto;
  }
</style>
